import "../index.css";
import { useState } from "react";
import Button from "../components/button/button";
import PolicyContainer from "../components/policy/policyContainer";
import axios from "axios";
import { baseURL } from "../baseURL";

const EmbeddedFormContact = ({ onSuccess, onError }) => {
  const [formData, setFormData] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmitContactForm = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${baseURL}/api/submit-contact-form`,
        formData,
        {
          withCredentials: "true", // This matches the backend CORS policy
          headers: { "Content-Type": "application/json" },
        }
      );

      if (response.status === 200) {
        onSuccess("contact");
      }
    } catch (error) {
      console.error("Error submitting form:", error.response || error.message);
      onError(error);
    }
  };

  return (
    <form id="contactForm" onSubmit={handleSubmitContactForm}>
      <p>
        Providing your contact information enables us to share best practices,
        communicate updates, and network with our global wildfire prevention
        community.
      </p>

      <div className="form-group">
        <label htmlFor="firstName">First Name*</label>
        <input
          type="text"
          id="firstName"
          name="firstName"
          onChange={handleChange}
          value={formData.firstName}
          required
        />
      </div>

      <div className="form-group">
        <label htmlFor="lastName">Last Name*</label>
        <input
          type="text"
          id="lastName"
          name="lastName"
          onChange={handleChange}
          value={formData.lastName}
          required
        />
      </div>

      <div className="form-group">
        <label htmlFor="email">Email*</label>
        <input
          type="email"
          id="email"
          name="email"
          onChange={handleChange}
          value={formData.email}
          required
        />
      </div>

      <div className="form-group">
        <label htmlFor="organization">Organization</label>
        <input
          type="text"
          id="organization"
          name="organization"
          onChange={handleChange}
          value={formData.organization}
        />
      </div>

      <div className="form-group">
        <label htmlFor="role">Role</label>
        <input
          type="text"
          id="role"
          name="role"
          onChange={handleChange}
          value={formData.role}
        />
      </div>

      <div className="form-group">
        <label htmlFor="zipCode">Zip/Postal Code*</label>
        <input
          type="text"
          id="zipCode"
          name="zipCode"
          onChange={handleChange}
          value={formData.zipCode}
          required
          minLength={4}
        />
      </div>

      <div className="form-group">
        <label htmlFor="message">Message</label>
        <textarea
          id="message"
          name="message"
          cols="50"
          rows="5"
          onChange={handleChange}
          value={formData.message}
        ></textarea>
      </div>

      <fieldset>
        <legend>Subscribe</legend>
        <div className="form-check">
          <input
            type="checkbox"
            id="subscribe"
            name="subscribe"
            onChange={handleChange}
            value={formData.subscribe}
          />
          <label htmlFor="subscribe">
            Receive exclusive updates on events, news, and access to weekly
            Consortium meetings
          </label>
        </div>
      </fieldset>

      <fieldset>
        <legend>Sign up</legend>
        <div className="form-check">
          <input
            type="checkbox"
            id="sign_up"
            name="sign_up"
            onChange={handleChange}
            value={formData.sign_up}
          />
          <label htmlFor="sign_up">Attend weekly Consortium meetings</label>
        </div>
      </fieldset>

      <fieldset>
        <legend>Explore</legend>
        <div className="form-check">
          <input
            type="checkbox"
            id="sponsor"
            name="sponsor"
            onChange={handleChange}
            value={formData.sponsor}
          />
          <label htmlFor="sponsor">Sponsor Programs</label>
        </div>
        <div className="form-check">
          <input
            type="checkbox"
            id="partner"
            name="partner"
            onChange={handleChange}
            value={formData.partner}
          />
          <label htmlFor="partner">Partner Program</label>
        </div>
      </fieldset>

      <fieldset>
        <legend>Apply to</legend>
        <div className="form-check">
          <input
            type="checkbox"
            id="innovation_showcase"
            name="innovation_showcase"
            onChange={handleChange}
            value={formData.innovation_showcase}
          />
          <label htmlFor="innovation_showcase">
            Present in Wildfire Innovation Showcase
          </label>
        </div>
        <div className="form-check">
          <input
            type="checkbox"
            id="demo_my_product"
            name="demo_my_product"
            onChange={handleChange}
            value={formData.demo_my_product}
          />
          <label htmlFor="demo_my_product">
            Demo my product and/or company
          </label>
        </div>
      </fieldset>

      <fieldset>
        <legend>Get Involved</legend>
        <div className="form-check">
          <input
            type="checkbox"
            id="Collaborate"
            name="Collaborate"
            onChange={handleChange}
            value={formData.collaborate}
          />
          <label htmlFor="Collaborate">Collaborate on opportunities</label>
        </div>
        <div className="form-check">
          <input
            type="checkbox"
            id="Co-apply"
            name="Co-apply"
            onChange={handleChange}
            value={formData.co_apply}
          />
          <label htmlFor="Co-apply">
            Co-apply to grant or funding opportunities
          </label>
        </div>
        <div className="form-check">
          <input
            type="checkbox"
            id="wildfire_resilience_scorecard"
            name="wildfire_resilience_scorecard"
            onChange={handleChange}
            value={formData.wildfire_resilience_scorecard}
          />
          <label htmlFor="wildfire_resilience_scorecard">
            Pilot the Community Wildfire Resilience Scorecard
          </label>
        </div>
      </fieldset>

      <PolicyContainer text="Contact Us" />

      <Button
        text="Contact Us"
        color="var(--green)"
        className="pop-up-btn"
        type="submit"
      />
    </form>
  );
};

export default EmbeddedFormContact;
